// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Batch Amortization Movement'"></sub-header>
  <div class="alert alert--danger">
    Moving amortization doesn't recalculate interest, penalties, principal, custom fees and accrual. <br>
    If amortization falls on non working branch date or on holiday, it will be moved according to product configuration. <br>
    Effective interest rate is always recalculated. <br>
    Operation is irreversible
  </div>

  <h2 class="section-header">Please confirm the following:</h2>
  <form name="\$ctrl.form">
    <table class="misc-transaction__table table">
      <tbody>
      <tr>
        <td>Loan movement start date:</td>
        <td>
          <date
            required
            init-with-null="true"
            ng-model="\$ctrl.request.loanMoratoriumStartDate"
            max="\$ctrl.request.loanMoratoriumMaxDate">
          </date>
        </td>
      </tr>
      <tr>
        <td>Movement type:</td>
        <td>
          <select
            ng-model="\$ctrl.request.amortizationMovementType"
            ng-options="m.value as m.label for m in \$ctrl.movementTypeOptions"
            ng-change="\$ctrl.movementTypeOnChange()"
            required>
          </select>
        </td>
      </tr>
      <tr ng-if="\$ctrl.isPaymentIntervalDisplayed()">
        <td>Payment Interval:</td>
        <td>
          <select
            ng-model="\$ctrl.request.paymentIntervalDefinitionId"
            ng-options="o.id as o.name for o in \$ctrl.paymentIntervals"
            required>
          </select>
        </td>
      </tr>
      <tr ng-if="\$ctrl.isNoOfIntervalsDisplayed()">
        <td>{{\$ctrl.getNoOfIntervalLabel()}}</td>
        <td>
          <input
            type="number"
            required
            ng-min="1"
            ng-model="\$ctrl.request.intervalCount"
          />
        </td>
      </tr>
      <tr>
        <td>File:</td>
        <td>
          <file-id-upload
            single-file="true"
            ng-model="\$ctrl.request.fileId"
            validate-uploaded
            required
            show-remarks="false"
            enable-webcam="false"
            max-files="1"
          ></file-id-upload>
        </td>
      </tr>
    </table>

    <div class="summary-actions">
      <button
        type="button"
        class="btn btn-info"
        ng-click="\$ctrl.downloadSampleFile()">
        Download sample file
      </button>
      <button
        type="submit"
        class="btn btn-success"
        ng-disabled="\$ctrl.form.\$invalid"
        command-access="PerformBatchAmortizationMovement"
        ng-click="\$ctrl.execute()">
        Execute
      </button>
      <button class="btn btn-info"
              ng-click="\$ctrl.downloadSummary()"
              type="button"
              ng-if="\$ctrl.commandId">
        Last movement summary
      </button>
    </div>
  </form>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/batch/loans/batch-loan-amortization-movement.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;